import { Button } from '@navi/web-ui/lib/primitives';
import React from 'react';
import styles from './index.module.scss';
import { LoadingIcon } from '@navi/web-ui/lib/icons';

interface StepButtonProps {
  onCancel: () => void;
  onAction: () => void;
  actionText: string;
  isLoading?: boolean;
  disabled?: boolean;
}

const StepsButton: React.FC<StepButtonProps> = ({
  onCancel,
  onAction,
  actionText,
  isLoading = false,
  disabled = false
}) => {
  return (
    <div className={styles.modalFooter}>
      <Button fullWidth variant="secondary" size="medium" onClick={onCancel} disabled={isLoading}>
        Cancel
      </Button>
      <Button
        fullWidth
        variant="primary"
        size="medium"
        onClick={onAction}
        disabled={isLoading || disabled}
      >
        {isLoading ? <LoadingIcon color="white" /> : actionText}
      </Button>
    </div>
  );
};

export default StepsButton;
